module.exports = __webpack_public_path__ + "img/tommy_side.d0424f05.png";